import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import Reveal from '@/components/base/Reveal';
import { services } from '@/mocks/site';

export default function ExpertiseGrid() {
  return (
    <section className="border-t border-background-200 bg-background-100 py-20 md:py-28 lg:py-32">
      <Container>
        <SectionLabel index="02" label="Expertise" />
        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-16 lg:grid-cols-4 lg:gap-6">
          <Reveal className="lg:col-span-2">
            <h2 className="font-heading text-4xl font-light leading-[1.05] tracking-[-0.02em] md:text-5xl">
              Disciplines that make a difference.
            </h2>
          </Reveal>
          <Reveal delay={100} className="lg:col-span-2 lg:self-end">
            <p className="max-w-md text-[15px] leading-[1.7] text-foreground-700 md:text-base">
              Six connected practice areas, led by partners and brought together whenever a client&rsquo;s question crosses more than one discipline.
            </p>
            <Link to="/expertise" className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:text-primary-500">
              <i className="ri-arrow-right-line" /> <span className="ed-link">All expertise</span>
            </Link>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 80} className="border-l border-background-300/80 px-0 pb-14 pl-5 md:pl-6 lg:pr-8">
              <Link to={`/expertise#${s.slug}`} className="group block cursor-pointer">
                <p className="font-label text-[11px] text-primary-500">{s.index}</p>
                <h3 className="mt-6 min-h-[2.6em] text-xl font-normal leading-snug text-foreground-950 md:text-[22px]">
                  <span className="ed-link">{s.title}</span>
                </h3>
                <div className="mt-6 aspect-[4/5] w-full max-w-[300px] overflow-hidden bg-background-200">
                  <img src={s.image} alt={`${s.title} — AVENOR accounting`} title={s.title} className="editorial-img h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.02]" />
                </div>
                <p className="mt-6 max-w-[300px] text-sm leading-relaxed text-foreground-700">{s.summary}</p>
                <span className="mt-5 inline-flex items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 group-hover:text-primary-500">
                  Read more <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}